// extracted by mini-css-extract-plugin
module.exports = {"cardButton":"styles_cardButton__20Cqu","selected":"styles_selected__3oYa1","card":"styles_card__35y-Z","question":"styles_question__24jO2"};